<!--
 * @Description: 资金管理批复记录
 * @Author: xu wei
 * @Date: 2020-02-27 17:43:13
 * @LastEditTime: 2020-09-01 15:43:50
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>资金管理</el-breadcrumb-item>
        <el-breadcrumb-item>批复记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class="tit">起始时间：</span>
          <!-- <el-date-picker style="width:338px;" v-model="time" size="small" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker> -->
          <el-date-picker style="width: 190px" v-model="time1" size="small" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
          </el-date-picker>
          <span style="font-size: 14px">至 </span>
          <el-date-picker style="width: 190px" v-model="time2" size="small" default-time="23:59:59" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
          </el-date-picker>
        </li>
        <li>
          <span class="tit">管理员：</span>
          <el-select style="width: 120px" v-model="conservatorpage" clearable size="small" placeholder="请选择">
            <el-option v-for="(item, i) in conservatordrow" :key="'conservator' + i" :label="item.account"
              :value="item.id"></el-option>
          </el-select>
        </li>
        <li>
          <span class="tit">批复结果：</span>
          <span class="txtbox">
            <el-select style="width: 120px" v-model="approvalResults" clearable size="small" placeholder="请选择">
              <el-option label="已付款" :value="1"></el-option>
              <el-option label="未付款" :value="0"></el-option>
            </el-select>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="
              () => {
                pageIndex = 1;
                getlist();
                replyStatic();
              }
            ">查询</el-button>
          </span>
        </li>
      </ul>
    </div>
    <div class="gs_tablebox">
      <div style="
          height: 25px;
          margin-top: 20px;
          background: #fff;
          padding: 5px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        ">
        <span class="tit" style="font-size: 14px;pa">总计总额：
          <span style="color: red; font-weight: bold">{{ totalMoney }}</span> 元
        </span>
      </div>
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="replyDate" label="批复时间" min-width="160">
        </el-table-column>
        <el-table-column label="批复流水" min-width="170">
          <template slot-scope="scope">
            <span style="color: green; cursor: pointer; text-decoration: underline"
              @click="replyDetail(scope.row.id)">{{ scope.row.serialNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="批复笔数">
          <template slot-scope="scope">
            <span style="color: red; font-weight: bold">{{
                scope.row.total
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="总金额">
          <template slot-scope="scope">
            <span style="color: green; font-weight: bold">{{
                scope.row.totalAmount.toFixed(2)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="批复人" width="140">
        </el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.state ? 'green' : 'red' }">{{
                scope.row.state ? "已付款" : "待批复"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作" width="200">
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="primary" :disabled="scope.row.state" @click="replyPass(scope.row.id,true)">确认付款</el-button> -->
            <el-select style="display: inline-block; width: 140px; margin: 0 10px" v-model="scope.row.extra"
              size="small" placeholder="请选择">
              <el-option label="默认格式" :value="0" @click.native="exportDefault(scope.row.id)"></el-option>
              <el-option label="招商银行" :value="1" @click.native="exportBank(scope.row.id)"></el-option>
              <el-option label="导出TXT" :value="2" @click.native="exportTxt(scope.row.id)"></el-option>
              <el-option label="确认付款（代付）" :disabled="scope.row.state" :value="3"
                @click.native="applyPaid(scope.row.id)"></el-option>
              <el-option label="确认付款（手动打款）" :disabled="scope.row.state" :value="3"
                @click.native="replyPass(scope.row.id, true, scope.row.state)"></el-option>
              <el-option label="驳回" :disabled="scope.row.state" :value="4"
                @click.native="replyPass(scope.row.id, false, scope.row.state)"></el-option>
              <el-option label="明细" :value="5" @click.native="replyDetail(scope.row.id)"></el-option>
            </el-select>
            <!-- <el-button size="mini" type="danger" :disabled="scope.row.state" @click="replyPass(scope.row.id,false)">驳回</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 订单详情的弹框 -->
    <el-dialog title="批复详情" :visible.sync="dialog.show" @close="dialoginit" custom-class="gs_dialog" width="1350px">
      <div class="gs_tablebox">
        <el-table ref="moduleTable" max-height="500" size="mini" :data="dialog.tableData" border style="width: 100%"
          stripe>
          <el-table-column prop="replyDate" label="商户名/账号" width="110">
            <template slot-scope="scope">
              <p>{{ scope.row.nickName }}</p>
              <p style="color: #666">{{ scope.row.account }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="applyDate" label="申请时间" width="160"></el-table-column>
          <el-table-column prop="serialNumber" label="流水号" width="180"></el-table-column>
          <el-table-column prop="realName" label="收款人"></el-table-column>
          <el-table-column prop="bankName" label="收款银行"></el-table-column>
          <el-table-column prop="bankNumber" label="收款账号"></el-table-column>
          <el-table-column label="金额">
            <template slot-scope="scope">
              <span style="color: green; font-weight: bold">{{
                  scope.row.amount.toFixed(2)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="手续费">
            <template slot-scope="scope">
              <span style="color: red; font-weight: bold">{{
                  scope.row.charge.toFixed(2)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="描述"></el-table-column>
          <el-table-column prop="completeDate" label="完成时间" width="160"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span class="stateColor" :class="'color' + scope.row.state">{{
                  scope.row.state | fstate
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" :disabled="scope.row.state === 1" @click="dialogPass(scope.row.id)">
                驳回</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="gs_pagenumber">
          <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
            :current-page="dialog.pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="dialog.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="dialog.total">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="代付通道" :visible.sync="dialogPaid">
      <el-select v-model="galleryId" placeholder="请选择代付通道">
        <el-option v-for="item in galleries" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
     <span slot="footer" class="dialog-footer">
    <el-button @click="dialogPaid = false">取 消</el-button>
    <el-button type="primary" @click="ApplyRechargePaid()">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import { url } from "../../assets/js/version";
export default {
  data() {
    return {
      time1: this.getCerentTime(true), // 开始时间
      time2: this.getCerentTime(false), // 开始时间
      conservatorpage: "", // 管理员
      conservatordrow: [], // 管理员下拉
      approvalResults: "", // 批复结果
      totalMoney: 0, // 总计总额
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      dialog: {
        show: false,
        ReplyId: "", // id
        pageIndex: 1, // 页码
        pageSize: 10, // 每页的条数
        total: 0, // 总数据的条数
        tableData: [],
      },
      tableData: [],
      dialogPaid: false,
      paidId: 0,
      galleries: [],
      galleryId: 0,
    };
  },
  filters: {
    fstate: function (data) {
      let state = "";
      switch (data) {
        case 0:
          state = "全部";
          break;
        case 1:
          state = "成功";
          break;
        case 2:
          state = "付款中";
          break;
        case 3:
          state = "审核中";
          break;
        case 4:
          state = "待付款";
          break;
        case 5:
          state = "审核失败";
          break;
        case 6:
          state = "拒绝付款";
          break;
      }
      return state;
    },
  },
  methods: {
    // 批复列表
    getlist() {
      this.$api.money
        .replylist({
          StartTime: this.time1 ? this.time1 : null,
          EndTime: this.time2 ? this.time2 : null,
          UserId: this.conservatorpage === "" ? 0 : this.conservatorpage,
          State: this.approvalResults === "" ? -1 : this.approvalResults,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize,
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers["x-pagination"]).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 默认格式导出
    exportDefault(id) {
      let addressUrl =
        url + "/api/Download/OutpuDefaultExcelAsync?ReplyId=" + id;
      // 创建隐藏的可下载链接
      let eleLink = document.createElement("a");
      eleLink.style.display = "none";
      // 字符内容转变成blob地址
      eleLink.href = addressUrl;
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    // 招商银行导出
    exportBank(id) {
      let addressUrl = url + "/api/Download/OutputCMBExcelAsync?ReplyId=" + id;
      // 创建隐藏的可下载链接
      let eleLink = document.createElement("a");
      eleLink.style.display = "none";
      // 字符内容转变成blob地址
      eleLink.href = addressUrl;
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    // txt导出
    exportTxt(id) {
      let addressUrl = url + "/api/Download/OutputTxtAsync?ReplyId=" + id;
      // 创建隐藏的可下载链接
      let eleLink = document.createElement("a");
      eleLink.style.display = "none";
      // 字符内容转变成blob地址
      eleLink.href = addressUrl;
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    // 获取批复管理员列表
    userDrow() {
      this.$api.money
        .replyUser()
        .then((data) => {
          if (data.status === 200) {
            this.conservatordrow = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 获取批复列表金额统计
    replyStatic() {
      this.$api.money
        .replyStatic({
          StartTime: this.time1 ? this.time1 : null,
          EndTime: this.time2 ? this.time2 : null,
          UserId: this.conservatorpage === "" ? 0 : this.conservatorpage,
          State: this.approvalResults === "" ? -1 : this.approvalResults,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize,
        })
        .then((data) => {
          if (data.status === 200) {
            this.totalMoney = data.data.toFixed(2);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 批复通过和驳回
    replyPass(id, type, state) {
      if (state) {
        return;
      }
      this.$api.money
        .replyWidthdraw({
          managerSettlementIdParameters: [{ id: id }],
          state: type,
        })
        .then((data) => {
          if (data.status === 200) {
            if (type) {
              this.$messageSuccess("批复通过！");
            } else {
              this.$messageSuccess("驳回成功！");
            }
            this.getlist();
            this.replyStatic();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    applyPaid(id) {
      this.paidId = id;
      this.dialogPaid = true;
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
      this.replyStatic();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
      this.replyStatic();
    },
    // 弹框中批复详情列表
    replyDetail(id) {
      this.$api.money
        .replyDetailList({
          ReplyId: id,
          PageNumber: this.dialog.pageIndex,
          PageSize: this.dialog.pageSize,
        })
        .then((data) => {
          if (data.status === 204) {
            this.dialog.tableData = [];
            this.dialog.total = 0;
          } else if (data.status === 200) {
            this.dialog.tableData = data.data;
            this.dialog.total = JSON.parse(
              data.headers["x-pagination"]
            ).TotalCount;
            this.dialog.ReplyId = id;
            this.dialog.show = true;
            this.$nextTick(() => {
              this.$refs.moduleTable.doLayout();
            });
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 弹框中的列表驳回
    dialogPass(id) {
      this.$api.money
        .dialogWidthdraw({ id: id })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("驳回成功！");
            this.replyDetail(this.dialog.ReplyId);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 弹框的初始化
    dialoginit() {
      this.dialog.ReplyId = ""; // id
      this.dialog.pageIndex = 1; // 页码
      this.dialog.pageSize = 10; // 每页的条数
      this.dialog.total = 0; // 总数据的条数
      this.dialog.tableData = [];
      this.getlist();
      this.replyStatic();
    },
    // 弹框中当每页条数变化时
    handleSizeChange1(data) {
      this.dialog.pageSize = data;
      this.dialog.pageIndex = 1;
      this.replyDetail();
    },
    // 弹框当前的页码变化时
    handleCurrentChange1(data) {
      this.dialog.pageIndex = data;
      this.replyDetail();
    },
    GetGalleryInfo() {
      this.$api.money
        .GetGalleryInfo()
        .then((data) => {
          if (data.status === 200) {
            this.galleries = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    ApplyRechargePaid(){
       this.dialogPaid = false;
       this.$api.money
        .ApplyPaid({PaidId:this.paidId,GalleryId:this.galleryId})
        .then((data) => {         
          if (data.status === 200) {
             this.$messageSuccess("申请成功，实际结果已异步通知为准！");
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    }
  },
  created() {
    this.getlist();
    this.userDrow();
    this.replyStatic();
    this.GetGalleryInfo();
  },
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;

  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;

      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }

      .txtbox {
        display: inline-block;
      }
    }
  }
}

.tableinfo {
  background: #fff;
  padding: 8px 20px;

  table {
    width: 100%;
    color: #272727;
    font-size: 14px;

    td {
      height: 30px;
    }

    .c_3fa396 {
      color: #3fa396;
    }
  }
}

.stateColor {
  display: inline-block;
  padding: 3px 5px;
  background: green;
  text-align: center;
  color: #fff;
  min-width: 50px;
  border-radius: 4px;

  &.color1 {
    background: green;
  }

  &.color2 {
    background: rgb(136, 209, 27);
  }

  &.color3 {
    background: rgb(14, 141, 130);
  }

  &.color4 {
    background: rgb(137, 47, 255);
  }

  &.color5 {
    background: #ccc;
  }

  &.color6 {
    background: rgb(47, 154, 255);
  }
}
</style>
